import type { StyleConfig } from "@chakra-ui/theme-tools"

/**
 * @see https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/text.ts
 */
export const Text: StyleConfig = {
  baseStyle: {
    fontSize: "16",
  },
  sizes: {
    sm: {
      fontSize: "14",
    },
    md: {
      fontSize: "16",
    },
    lg: {
      fontSize: "18",
    },
  },
  defaultProps: {
    size: "md",
  },
}
